import { Component, HostBinding, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-nav-vertical-item',
  templateUrl: './nav-vertical-item.component.html',
  styleUrls: ['./nav-vertical-item.component.scss'],
  standalone: true,
  imports:[
    RouterModule,
    MatIconModule,
    CommonModule
  ]
})
export class NkNavVerticalItemComponent {
  @HostBinding('class') classes = 'nav-item';
  @Input() item: any;
   active: boolean = false;

  setActive(): void {
    this.active = true;
  }
}
